/**
 * Created by Ning Jiang on 2/7/2018.
 */

import {ILayerConfig, ILayersConfig} from "@nolimitcity/slot-game/bin/core/stage/ILayersConfig";
import {
    CustomLayerScaleOptions,
    LayerScaleOption,
    ScaleMethod,
    ScaleTarget
} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";

export interface IHorribleHeroesLayerConfig extends ILayersConfig {
    readonly BACKGROUND: ILayerConfig;
    readonly SCATTER_METER: ILayerConfig;
    readonly REEL_BACKGROUND: ILayerConfig;
    readonly SCATTER_METER_PORTRAIT: ILayerConfig;
    readonly REEL_ATTENTION: ILayerConfig;
    readonly SYMBOLS: ILayerConfig;
    readonly ANTI_STRIKE: ILayerConfig;
    readonly WILD_ENERGY: ILayerConfig;
    readonly SYMBOL_WIN_ANIMATION: ILayerConfig,
    readonly LOGO: ILayerConfig;
    readonly FREE_SPIN: ILayerConfig;
    readonly STICKY_WILDS: ILayerConfig;
    readonly SCATTER_OVERLAY: ILayerConfig;
    readonly HEROES_INTRO: ILayerConfig;
    readonly BIG_WIN: ILayerConfig;
    readonly WIN_COUNT_UP: ILayerConfig;
    readonly MAYHEM_INTRO: ILayerConfig,
    readonly DEBUG_OVERLAY: ILayerConfig;
    readonly INTRO: ILayerConfig;
    readonly DEMO: ILayerConfig;
}

export class HorribleHeroesLayerConfig {
    public static customOptions: CustomLayerScaleOptions = {
        frame: {x: 0, y: 0, width: 720, height: 620},
        placement: {
            desktop: {
                landscape: {x: 0.5, y: 0.5}
            },
            mobile: {
                landscape: {x: 0.5, y: 0.5},
                portrait: {x: 0.5, y: 0.5}
            }
        },
    };

    public static reelBackground: CustomLayerScaleOptions = {
        target: {
            desktop: {
                landscape: ScaleTarget.STAGE
            },
            mobile: {
                landscape: ScaleTarget.STAGE,
                portrait: ScaleTarget.WINDOW
            }
        },
        placement: {
            desktop: {
                landscape: {x: 0.5, y: 1}
            },
            mobile: {
                landscape: {x: 0.5, y: 1},
                portrait: {x: 0.5, y: 1}
            }
        },
        method: {
            desktop: {
                landscape: ScaleMethod.FIT
            },
            mobile: {
                landscape: ScaleMethod.FIT,
                portrait: ScaleMethod.FIT
            }
        }
    };

    public static introConfig: CustomLayerScaleOptions = {
        target: ScaleTarget.WINDOW,
        method: ScaleMethod.FIT,
        frame: {x: 0, y: 0, width: 720, height: 720},
        placement: {x: 0.5, y: 0.5}
    };

    public static BACKGROUND: ILayerConfig = {
        name: "BACKGROUND",
        customOptions: HorribleHeroesLayerConfig.introConfig
    };

    public static REEL_BACKGROUND: ILayerConfig = {
        name: "REEL_BACKGROUND",
        customOptions: HorribleHeroesLayerConfig.reelBackground
    };

    public static SCATTER_METER: ILayerConfig = {
        name: "SCATTER_METER",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static MAYHEM_INTRO: ILayerConfig = {
        name: "MAYHEM_INTRO",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static SCATTER_METER_PORTRAIT: ILayerConfig = {
        name: "SCATTER_METER_PORTRAIT",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static REEL_ATTENTION: ILayerConfig = {
        name: "REEL_ATTENTIONS",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static SYMBOLS: ILayerConfig = {
        name: "symbols",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static ANTI_STRIKE: ILayerConfig = {
        name: "antiStrike",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static WILD_ENERGY: ILayerConfig = {
        name: "wildEnergy",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static FREE_SPIN: ILayerConfig = {
        name: "FREE_SPIN",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static SYMBOL_WIN_ANIMATION: ILayerConfig = {
        name: "SYMBOL_WIN_ANIMATION",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static STICKY_WILDS: ILayerConfig = {
        name: "STICKY_WILDS",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };
    public static INDI_SYM_WIN: ILayerConfig = {
        name: "INDI_SYM_WIN",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static SCATTER_OVERLAY: ILayerConfig = {
        name: "scatterOverlay",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static HEROES_INTRO: ILayerConfig = {
        name: "HEROES_INTRO",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static WIN_COUNT_UP: ILayerConfig = {
        name: "WIN_COUNT_UP",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static LOGO: ILayerConfig = {
        name: "LOGO",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static DEBUG_OVERLAY: ILayerConfig = {
        name: "DEBUG_OVERLAY",
        scaleOption: LayerScaleOption.NONE
    };

    public static INTRO: ILayerConfig = {
        name: "intro",
        customOptions: HorribleHeroesLayerConfig.introConfig
    };

    public static BIG_WIN: ILayerConfig = {
        name: "BIG_WIN",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static BIG_WIN_FOUNTAIN: ILayerConfig = {
        name: "BIG_WIN_FOUNTAIN",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static DEMO: ILayerConfig = {
        name: "DEMO",
        customOptions: HorribleHeroesLayerConfig.customOptions
    };

    public static getConfig(): IHorribleHeroesLayerConfig {
        return {
            BACKGROUND: HorribleHeroesLayerConfig.BACKGROUND,
            SCATTER_METER: HorribleHeroesLayerConfig.SCATTER_METER,
            REEL_BACKGROUND: HorribleHeroesLayerConfig.REEL_BACKGROUND,
            SCATTER_METER_PORTRAIT: HorribleHeroesLayerConfig.SCATTER_METER_PORTRAIT,
            SYMBOLS: HorribleHeroesLayerConfig.SYMBOLS,
            WILD_ENERGY: HorribleHeroesLayerConfig.WILD_ENERGY,
            REEL_ATTENTION: HorribleHeroesLayerConfig.REEL_ATTENTION,
            LOGO: HorribleHeroesLayerConfig.LOGO,
            STICKY_WILDS: HorribleHeroesLayerConfig.STICKY_WILDS,
            ANTI_STRIKE: HorribleHeroesLayerConfig.ANTI_STRIKE,
            SCATTER_OVERLAY: HorribleHeroesLayerConfig.SCATTER_OVERLAY,
            SYMBOL_WIN_ANIMATION: HorribleHeroesLayerConfig.SYMBOL_WIN_ANIMATION,
            INDI_SYM_WIN:HorribleHeroesLayerConfig.INDI_SYM_WIN,
            BIG_WIN_FOUNTAIN: HorribleHeroesLayerConfig.BIG_WIN_FOUNTAIN,
            BIG_WIN: HorribleHeroesLayerConfig.BIG_WIN,
            WIN_COUNT_UP: HorribleHeroesLayerConfig.WIN_COUNT_UP,
            MAYHEM_INTRO: HorribleHeroesLayerConfig.MAYHEM_INTRO,
            FREE_SPIN: HorribleHeroesLayerConfig.FREE_SPIN,
            HEROES_INTRO: HorribleHeroesLayerConfig.HEROES_INTRO,
            DEBUG_OVERLAY: HorribleHeroesLayerConfig.DEBUG_OVERLAY,
            INTRO: HorribleHeroesLayerConfig.INTRO,
            DEMO: HorribleHeroesLayerConfig.DEMO
        };
    }
}